import React from 'react';

type fillRuleType = 'nonzero' | 'evenodd' | 'inherit' | undefined;
type clipRuleType = fillRuleType;

export type IconPropType = {
    icon: string[];
    className?: string;
    size?: string;
    fill?: string;
    viewBoxX?: string;
    viewBoxY?: string;
    viewBoxMax?: string;
    fillRule?: fillRuleType;
    clipRule?: clipRuleType;
    stroke?: string;
    strokeWidth?: string;
    ariaLabel?: string;
    tabIndex?: number;
    style?: Record<string, string>;
    title?: string;
};
const Icon = ({
    icon = [],
    className = '',
    size = '22',
    fill = 'currentColor',
    viewBoxX = '0',
    viewBoxY = '0',
    viewBoxMax = '1024',
    ariaLabel,
    ...rest
}: IconPropType) => (
    <svg
        className={className}
        fill={fill}
        width={size}
        height={size}
        viewBox={`${viewBoxX} ${viewBoxY} ${viewBoxMax} ${viewBoxMax}`}
        role="img"
        aria-label={ariaLabel}
        title="icon"
        {...rest}
    >
        {icon.map((path, index) => (
            <path key={index} d={path} />
        ))}
    </svg>
);

export default Icon;
